import { actionTypes } from './actions';

export const initialState = {
  isVisible: false,
  // Remembers how the survey ended so it is not offered again before the
  // account's survey record has caught up.
  answeredStatus: null,
};

const educatorsSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_EDUCATORS_SURVEY:
      return { ...state, isVisible: true };

    case actionTypes.HIDE_EDUCATORS_SURVEY:
      return {
        ...state,
        isVisible: false,
        answeredStatus: action.payload?.status || null,
      };

    default:
      return state;
  }
};

export default educatorsSurveyReducer;
